import React from 'react';
import classNames from 'classnames';

export default function PlayerButton({ children, disabled, onClick, selected }) {
  const disabledCss = 'opacity-25 cursor-not-allowed'
  return (
    <button
      onClick={onClick}
      className={classNames('px-2 mx-1 rounded', {
        [disabledCss]: disabled,
        'text-secondary': !selected,
        'text-default': selected,
        'hover:text-default hover:border hover:border-white-darkest hover:bg-white-darkest': !disabled,
      })}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
